import { fetchError, fetchStart, fetchSuccess } from "../../redux/actions";
import {
  setAllTests,
  setAllQuestions,
  removeQustion,
  addQustion,
  setCreatedQuiz,
  removeQuiz,
  setSingleQuiz,
  setActiveQuizId,
  setCommentsById,
  setQuizTicketList,
  removeSingleTicketById,
  setKeys,
  setKeysCurrentPage,
  setKeysTotalPages,
  removeKeyById,
  getAnswer,
  setScores,
  setScoresCurrentPage,
  setScoresTotalPages,
  removeScoreById,
  setTestsCurrentPage,
  setTestsTotalPage,
  setCoins,
  setCoinsCurrentPage,
  setCoinsTotalPages,
  setQuizCheats,
  setQuizCheatsCurrentPage,
  setQuizCheatsTotalPages,
  setWords,
  setWordsCurrentPage,
  setWordsTotalPages,
  removeWordById,
  setParticipants,
  setParticipantsCurrentPage,
  setParticipantsTotalPages,
  setVows,
  setVowsCurrentPage,
  setVowsTotalPages,
  removeVowById,
  setWGEvents,
  setWGEventsCurrentPage,
  setWGEventsTotalPages,
  removeWGEventById,
  setAllMarathonEvents,
  setMarathonEventById,
  setMarathonQuestionsById,
} from "../../redux/actions/Tests";

import axios from "../auth/jwt/config";

const TestsRequests = {
  getAllTests: (page) => {
    return (dispatch) => {
      try {
        dispatch(fetchStart());
        axios
          .get(`/quiz/getall?page=${page}&limit=10`)
          .then(({ data }) => {
            dispatch(fetchSuccess());
            dispatch(setAllTests(data.docs));
            dispatch(setTestsCurrentPage(data.page));
            dispatch(setTestsTotalPage(data.totalPages));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msg));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  getAllQuestions: (quizId) => {
    return (dispatch) => {
      try {
        dispatch(fetchStart());
        axios
          .get(`/quizQuestion/getQuiz/${quizId}`)
          .then(({ data }) => {
            dispatch(fetchSuccess());
            dispatch(setAllQuestions(data.quizQuestions));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msg));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  updateSingleQuestion: (id, questionData) => {
    return (dispatch) => {
      try {
        axios
          .patch(`/quizQuestion/update/${id}`, questionData)
          .then(() => {
            dispatch(fetchSuccess("با موفقیت به روز رسانی شد"));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  removeSingleQuestion: (id) => {
    return (dispatch) => {
      try {
        axios
          .delete(`/quizQuestion/remove/${id}`)
          .then(() => {
            dispatch(fetchSuccess("با موفقیت حذف شد"));
            dispatch(removeQustion(id));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  addSingleQuestion: (question) => {
    return (dispatch) => {
      return new Promise((resolve, reject) => {
        try {
          axios
            .post(`/quizQuestion/create`, question)
            .then(({ data }) => {
              dispatch(fetchSuccess("با موفقیت اضافه شد"));
              dispatch(addQustion(data.quizQuestion));
              resolve(data);
            })
            .catch((error) => {
              if (error.response) {
                reject(error.response.data.msgFa);
              } else {
                reject(error.message);
              }
            });
        } catch (error) {
          reject(error.message);
        }
      });
    };
  },
  createTest: (test) => {
    return (dispatch) => {
      try {
        axios
          .post(`/quiz/create`, test)
          .then(({ data }) => {
            dispatch(fetchSuccess("با موفقیت اضافه شد"));
            dispatch(setCreatedQuiz(data.quiz));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  deleteTest: (id) => {
    return (dispatch) => {
      try {
        axios
          .delete(`/quiz/remove/${id}`)
          .then(() => {
            dispatch(fetchSuccess("با موفقیت حذف شد"));
            dispatch(removeQuiz(id));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  getQuizById: (id) => {
    return (dispatch) => {
      try {
        axios
          .get(`/quiz/getsingle/${id}`)
          .then(({ data }) => {
            dispatch(fetchSuccess());
            dispatch(setSingleQuiz(data.quiz));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  updateQuizById: (id, Quizdata) => {
    return (dispatch) => {
      try {
        axios
          .patch(`/quiz/update/${id}`, Quizdata)
          .then(() => {
            dispatch(fetchSuccess("با موفقیت به روز رسانی شد"));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  getActiveQuizId: () => {
    return (dispatch) => {
      try {
        axios
          .get(`/quiz/getActiveQuizId`)
          .then(({ data }) => {
            dispatch(fetchSuccess());
            dispatch(setActiveQuizId(data.activeQuizId));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  generateMiniQuizes: async (miniQuizes) => {
    let temp = [];

    if (miniQuizes.length === 0) {
      return temp;
    }

    for (const quizId of miniQuizes) {
      try {
        const response = await axios.get(`/quiz/getsingle/${quizId}`);
        temp.push({
          id: response.data.quiz._id,
          quiz: response.data.quiz.title,
        });
      } catch (error) {
        if (error.response) {
          console.log(error.response.data.msgFa);
        } else {
          console.log(error.message);
        }
      }
    }
    return temp;
  },
  activate: (quizId) => {
    return (dispatch) => {
      try {
        axios
          .patch(`/quiz/activate/${quizId}`)
          .then(() => {
            dispatch(fetchSuccess("آزمون مورد نظر با موفقیت فعال شد"));
            dispatch(setActiveQuizId(quizId));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  getCommentsByID: (quizId) => {
    return (dispatch) => {
      try {
        axios
          .get(`/quiz/comment/getAllByQuizId/${quizId}`)
          .then(({ data }) => {
            dispatch(fetchSuccess());
            if (data.hasOwnProperty("quizComments")) {
              dispatch(setCommentsById(data.quizComments));
            }
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  getCommentOwner: async (id) => {
    let owner = null;
    try {
      const response = await axios.get(`/user/getuser/${id}`);
      owner = response.data.user;
    } catch (error) {
      if (error.response) {
        console.log(error.response.data.msgFa);
      } else {
        console.log(error.message);
      }
    }
    return owner;
  },
  getQuizContribution: async (id) => {
    let statistics = 0;
    try {
      const response = await axios.get(`/quizTicket/getAllByQuizId/${id}`);
      statistics = response.data.quizTickets.length;
    } catch (error) {
      if (error.response) {
        console.log(error.response.data.msgFa);
      } else {
        console.log(error.message);
      }
    }
    return statistics;
  },
  getQuizTicketListByID: (quizId, searchStr) => {
    return (dispatch) => {
      try {
        axios
          .get(`/quizTicket/getAllByQuizId/${quizId}?searchString=${searchStr}`)
          .then(({ data }) => {
            dispatch(fetchSuccess());
            dispatch(setQuizTicketList(data.quizTickets));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  removeSingleTicket: (TicketId) => {
    return (dispatch) => {
      try {
        axios
          .delete(`/quizTicket/remove/${TicketId}`)
          .then(() => {
            dispatch(removeSingleTicketById(TicketId));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  getKeys: (page, searchStr) => {
    return (dispatch) => {
      try {
        axios
          .get(
            `/key/getall?page=${page}&limit=100&searchString=${searchStr || ""}`
          )
          .then(({ data }) => {
            dispatch(fetchSuccess());
            dispatch(setKeys(data.docs));
            dispatch(setKeysCurrentPage(data.page));
            dispatch(setKeysTotalPages(data.totalPages));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  removeKey: (keyId, totalItems, currentPage) => {
    return (dispatch) => {
      try {
        axios
          .delete(`/key/remove/${keyId}`)
          .then(() => {
            dispatch(removeKeyById(keyId));
            if (totalItems < 2) {
              if (currentPage !== 1) {
                TestsRequests.getKeys(currentPage - 1)(dispatch);
              }
            }
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  addKey: (keyData) => {
    return (dispatch) => {
      try {
        axios
          .post(`/key/create`, keyData)
          .then(() => {
            dispatch(fetchSuccess("با موفقیت افزوده شد"));
            TestsRequests.getKeys(1)(dispatch);
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  getAnswer: (userId, quizId) => {
    return (dispatch) => {
      try {
        axios
          .post(`/quizanswer/getall/usinguserdata`, {
            owner: userId,
            quizId: quizId,
          })
          .then(({ data }) => {
            dispatch(fetchSuccess());
            dispatch(getAnswer(data));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  getScores: (page, searchStr) => {
    return (dispatch) => {
      try {
        axios
          .get(
            `/score/getall?page=${page}&limit=100&searchString=${searchStr ||
              ""}`
          )
          .then(({ data }) => {
            dispatch(fetchSuccess());
            dispatch(setScores(data.docs));
            dispatch(setScoresCurrentPage(data.page));
            dispatch(setScoresTotalPages(data.totalPages));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  removeScore: (scoreId, totalItems, currentPage) => {
    return (dispatch) => {
      try {
        axios
          .delete(`/score/remove/${scoreId}`)
          .then(() => {
            dispatch(fetchSuccess("باموفقیت حذف شد"));
            dispatch(removeScoreById(scoreId));
            if (totalItems < 2) {
              if (currentPage !== 1) {
                TestsRequests.getScores(currentPage - 1)(dispatch);
              }
            }
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  createScore: (data) => {
    return (dispatch) => {
      try {
        axios
          .post(`/score/create`, data)
          .then(() => {
            TestsRequests.getScores(1)(dispatch);
            setTimeout(() => {
              dispatch(fetchSuccess("باموفقیت افزوده شد"));
            }, 1000);
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  getCoins: (page, searchStr) => {
    return (dispatch) => {
      try {
        axios
          .get(
            `/coin/getall?page=${page}&limit=100&searchString=${searchStr ||
              ""}`
          )
          .then(({ data }) => {
            dispatch(fetchSuccess());
            dispatch(setCoins(data.docs));
            dispatch(setCoinsCurrentPage(data.page));
            dispatch(setCoinsTotalPages(data.totalPages));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  deleteCoin: (id) => {
    return (dispatch) => {
      try {
        axios
          .delete(`/coin/remove/${id}`)
          .then(() => {
            dispatch(fetchSuccess());
            dispatch(TestsRequests.getCoins(1, ""));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  createCoin: (data) => {
    return (dispatch) => {
      try {
        axios
          .post(`/coin/create`, data)
          .then(() => {
            TestsRequests.getCoins(1)(dispatch);
            setTimeout(() => {
              dispatch(fetchSuccess("باموفقیت افزوده شد"));
            }, 1000);
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  getQuizCheats: (page) => {
    return (dispatch) => {
      try {
        axios
          .get(`/quizCheat/getall?page=${page}&limit=100`)
          .then(({ data }) => {
            dispatch(fetchSuccess());
            dispatch(setQuizCheats(data.docs));
            dispatch(setQuizCheatsCurrentPage(data.page));
            dispatch(setQuizCheatsTotalPages(data.totalPages));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  getWords: (page, searchStr) => {
    return (dispatch) => {
      try {
        axios
          .get(
            `/wordgame/pool/getall?page=${page}&limit=100&searchString=${searchStr ||
              ""}`
          )
          .then(({ data }) => {
            dispatch(fetchSuccess());
            dispatch(setWords(data.docs));
            dispatch(setWordsCurrentPage(data.page));
            dispatch(setWordsTotalPages(data.totalPages));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  removeWord: (keyId, totalItems, currentPage) => {
    return (dispatch) => {
      try {
        axios
          .delete(`/wordgame/pool/remove/${keyId}`)
          .then(() => {
            dispatch(removeWordById(keyId));
            if (totalItems < 2) {
              if (currentPage !== 1) {
                TestsRequests.getWords(currentPage - 1)(dispatch);
              }
            }
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  addWord: (word) => {
    return (dispatch) => {
      try {
        axios
          .post(`/wordgame/pool/create`, word)
          .then(() => {
            dispatch(fetchSuccess("با موفقیت افزوده شد"));
            TestsRequests.getWords(1)(dispatch);
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  addBatchWord: (file, eventId) => {
    return async (dispatch) => {
      const formData = new FormData();
      formData.append("csvFile", file);
      try {
        axios
          .post(`/wordgame/pool/createBatch/${eventId}`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then(() => {
            setTimeout(() => {
              dispatch(fetchSuccess("باموفقیت اضافه شد"));
            }, 500);
            TestsRequests.getWords(1)(dispatch);
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError("مشکل در آپلود "));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  getParticipants: (page, searchStr) => {
    return (dispatch) => {
      try {
        axios
          .get(
            `/wordgame/ticket/getall?page=${page}&limit=100&searchString=${searchStr ||
              ""}`
          )
          .then(({ data }) => {
            dispatch(fetchSuccess());
            dispatch(setParticipants(data.docs));
            dispatch(setParticipantsCurrentPage(data.page));
            dispatch(setParticipantsTotalPages(data.totalPages));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  getVows: (page) => {
    return (dispatch) => {
      try {
        axios
          .get(`/vow/getall?page=${page}&limit=100&topic=rb1405`)
          .then(({ data }) => {
            dispatch(fetchSuccess());
            dispatch(setVows(data.docs));
            dispatch(setVowsCurrentPage(data.page));
            dispatch(setVowsTotalPages(data.totalPages));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  removeVow: (vowId, totalItems, currentPage) => {
    return (dispatch) => {
      try {
        axios
          .delete(`/vow/remove/${vowId}`)
          .then(() => {
            dispatch(removeVowById(vowId));
            if (totalItems < 2) {
              if (currentPage !== 1) {
                TestsRequests.getVows(currentPage - 1)(dispatch);
              }
            }
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  addVow: (vowData) => {
    return (dispatch) => {
      try {
        axios
          .post(`/vow/addsingle`, vowData)
          .then(() => {
            dispatch(fetchSuccess("با موفقیت افزوده شد"));
            TestsRequests.getVows(1)(dispatch);
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  getWGEvents: (page, searchStr) => {
    return (dispatch) => {
      try {
        axios
          .get(
            `/wordgame/event/getall?page=${page}&limit=100&searchString=${searchStr ||
              ""}`
          )
          .then(({ data }) => {
            dispatch(fetchSuccess());
            dispatch(setWGEvents(data.docs));
            dispatch(setWGEventsCurrentPage(data.page));
            dispatch(setWGEventsTotalPages(data.totalPages));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  removeWGEvent: (keyId, totalItems, currentPage) => {
    return (dispatch) => {
      try {
        axios
          .delete(`/wordgame/event/remove/${keyId}`)
          .then(() => {
            dispatch(removeWGEventById(keyId));
            if (totalItems < 2) {
              if (currentPage !== 1) {
                TestsRequests.getWGEvents(currentPage - 1)(dispatch);
              }
            }
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  getAllMarathonEvents: () => {
    return (dispatch) => {
      try {
        dispatch(fetchStart());
        axios
          .get(`/marathonDanaie/event/getall/admin`)
          .then(({ data }) => {
            dispatch(fetchSuccess());
            dispatch(setAllMarathonEvents(data));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msg));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  getMarathonEventById: (id) => {
    return (dispatch) => {
      try {
        axios
          .get(`/marathonDanaie/event/get/${id}`)
          .then(({ data }) => {
            dispatch(fetchSuccess());
            dispatch(setMarathonEventById(data));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  createMarathonEvent: (eventData, history) => {
    return (dispatch) => {
      try {
        axios
          .post(`/marathonDanaie/event/create`, eventData)
          .then(() => {
            dispatch(fetchSuccess("با موفقیت اضافه شد"));
            TestsRequests.getAllMarathonEvents()(dispatch);
            if (history) {
              history.push("/marathonDanie");
            }
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  updateMarathonEventById: (id, eventData, history) => {
    return (dispatch) => {
      try {
        axios
          .patch(`/marathonDanaie/event/update/${id}`, eventData)
          .then(() => {
            dispatch(fetchSuccess("با موفقیت به روز رسانی شد"));
            TestsRequests.getAllMarathonEvents()(dispatch);
            if (history) {
              history.push("/marathonDanie");
            }
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  deleteMarathonEventById: (id) => {
    return (dispatch) => {
      try {
        axios
          .delete(`/marathonDanaie/event/remove/${id}`)
          .then(() => {
            dispatch(fetchSuccess("با موفقیت حذف شد"));
            TestsRequests.getAllMarathonEvents()(dispatch);
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  getMarathonQuestionsById: (id,category) => {
    return (dispatch) => {
      try {
        dispatch(fetchStart());
        axios
          .get(`/marathonDanaie/eventQuestion/getall/admin/${id}?category=${category}`)
          .then(({ data }) => {
            dispatch(fetchSuccess());
            dispatch(setMarathonQuestionsById(data));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
};

export default TestsRequests;
